<template>
  <menu-item
    :class="{
      'main-menu-report-tabs-mobile-item': true,
      'main-menu-report-tabs-mobile-item--has-dropdown': hasDropdownIcon,
      'main-menu-report-tabs-mobile-item--is-open': hasDropdownIcon && decorativeDropdown,
    }"
    :key="item.key"
    :icon="item.icon"
    @click="onClick"
    :selectable="!isDropdown"
    :selected="item.active"
    :decorative-dropdown="decorativeDropdown"
  >
    <template #content>
      <div class="main-menu-report-tabs-mobile-item__content">
        <div class="main-menu-report-tabs-mobile-item__title">
          {{ title }}
        </div>

        <div v-if="item.hasBookmarks" class="main-menu-report-tabs-mobile-item__bookmarks ml-16">
          <bookmark-add
            :index="bookmarkIndexes[item.meta.index]"
            :item="item.meta.item"
            :title="item.title"
          ></bookmark-add>
        </div>

        <div
          v-if="hasClose"
          class="main-menu-report-tabs-mobile-item__action ml-16"
          :class="{ 'main-menu-report-tabs-mobile-item__action--close': hasClose }"
        >
          <ui-icon
            color="inherit"
            class="main-menu-report-tabs-mobile-item__icon"
            @click="onClose(item.close($event))"
            icon="fas fa-times"
          ></ui-icon>
        </div>
      </div>
    </template>
  </menu-item>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import MenuItem from '@/components/menu/menu-item.vue';
import BookmarkAdd from '@/components/bookmark/bookmark-add.vue';

const props = withDefaults(
  defineProps<{
    item: {
      key: string;
      icon?: string;
      active?: boolean;
      name?: string;
      title?: string;
      hasBookmarks?: boolean;
      meta?: { index: number; item: unknown };
      close?: (event: Event) => void;
    };
    type?: 'dropdown' | 'tab';
    bookmarkIndexes?: number[];
    decorativeDropdown?: boolean | null;
  }>(),
  {
    type: 'tab',
    bookmarkIndexes: () => [],
    decorativeDropdown: null,
  },
);

const emit = defineEmits<{
  click: [event?: Event];
  close: [event?: Event];
  share: [event?: Event];
}>();

const isDropdown = computed(() => props.type === 'dropdown');

const title = computed(() => (isDropdown.value ? props.item.name : props.item.title));

const hasDropdownIcon = computed(() => isDropdown.value || null);

const hasClose = computed(() => !isDropdown.value && !!props.item.close);

const onClick = (event?: Event) => {
  emit('click', event);
};

const onClose = (event?: Event) => {
  emit('close', event);
};
</script>

<style lang="scss">
.main-menu-report-tabs-mobile-item {
  border-bottom: none;
  overflow: hidden;

  &--is-open {
    background-color: var(--color-white20);
  }

  &__title {
    flex-grow: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &--has-dropdown &__title {
    padding-right: 18px;
  }

  &__action {
    color: var(--color-white);
    &--close {
      color: var(--color-red);
    }
  }

  &__content {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
    align-items: center;
  }

  .menu-list-item__content {
    color: var(--color-white);

    &:hover {
      cursor: pointer;
      color: var(--color-green);
    }
  }
}
</style>
